import base from "@/store/utils/api-route/base";

const api = {
    getListMesin: `${base.masterData}edc/list_mesin_edc`,
    getListMesinAll: `${base.masterData}edc/list_mesin_edc_option`,
    getDataMesin: `${base.masterData}edc/rincian_data_mesin_edc`,
    getDetailMesin: `${base.masterData}edc/detail_mesin_edc`,
    getListProvider: `${base.masterData}edc/list_provider_akun`,
    getListOutlet: `${base.masterData}meta/list_outlet_sorting_meta`,
    getListSettlement: `${base.masterData}keuangan/list_rekening_owner`,
    getKodeAkunSettlement: `${base.masterData}keuangan/get_kode_keuangan_rekening`,
    createKodeAkun: `${base.masterData}keuangan/tambah_rekening_owner`,
    getIdAkun: `${base.masterData}edc/get_idakun_mesin_edc`,
    createMesin: `${base.masterData}edc/create_mesin_edc`,
    updateMesin: `${base.masterData}edc/update_mesin_edc`,
    deleteMesin: `${base.masterData}edc/delete_mesin_edc`,
    getListPembarayan: `${base.masterData}edc/list_riwayat_pembayaran_edc_perday`,
    getListSettlementEdc: `${base.masterData}edc/list_riwayat_settlement_edc`,
    getDetailSettlementEdc: `${base.masterData}edc/get_detail_settlement_edc`,
    createSettlement: `${base.masterData}edc/settlement_keuangan_edc`,
    tolakSettlement: `${base.masterData}edc/tolak_settlement_keuangan_edc`,
    setujuiSettlement: `${base.masterData}edc/setujui_settlement_keuangan_edc`,
    getRiwayatPembayaranEdc: `${base.masterData}edc/list_riwayat_pembayaran_edc`,
    export: {
        job: `${base.export}job`,
        track: `${base.export}track_redis_job`,
        delete: {
            cluster: `${base.export}delete_cluster_redis_job`,
            master: `${base.export}delete_master_redis_job`,
        },
    },
};

export default api;
